import React from "react";
import { WAREHOUSES } from "../lib/warehouses";

export default function WarehouseAddressCard({ warehouseId, customerName }) {
  const wh = WAREHOUSES[warehouseId];
  if (!wh) return null;

  const address = wh.address(customerName || "Your Name");

  return (
    <div style={{
      background: "var(--bg)",
      border: "0.5px solid var(--border)",
      borderRadius: "var(--radius-lg)",
      padding: "1rem 1.25rem",
      marginBottom: "1.25rem",
      boxShadow: "var(--shadow-sm)",
      display: "flex",
      gap: 16,
      alignItems: "flex-start",
    }}>
      <div style={{ fontSize: 32, flexShrink: 0 }}>{wh.flag}</div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 12, color: "var(--text-muted)", fontWeight: 600, textTransform: "uppercase", letterSpacing: ".04em", marginBottom: 6 }}>
          Your {wh.label} warehouse address
        </div>
        <div style={{ fontSize: 14, fontWeight: 600, lineHeight: 1.8, whiteSpace: "pre-line" }}>
          {address}
        </div>
        {wh.phone && (
          <div style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 6 }}>
            📞 {wh.phone}
          </div>
        )}
      </div>
      <button
        style={{ fontSize: 11, padding: "4px 10px", borderRadius: 8, border: "0.5px solid var(--border-md)", background: "transparent", cursor: "pointer", color: "var(--text-muted)", flexShrink: 0 }}
        onClick={() => {
          const text = address + (wh.phone ? `\n${wh.phone}` : "");
          navigator.clipboard.writeText(text).then(() => alert("Address copied!"));
        }}
      >
        Copy
      </button>
    </div>
  );
}
